import { Divider } from '@outdoorsyco/bonfire';
import { clsx } from 'clsx';
import React, { ReactNode } from 'react';

type TStickyComponentProps = {
  className?: string;
  children?: JSX.Element[];
};

interface IStickySectionProps {
  children: ReactNode;
  className?: string;
  includeMobile?: boolean;
  Component?: React.ComponentType<TStickyComponentProps>;
}

const BaseComponent = ({ children, className }: TStickyComponentProps) => (
  <div className={clsx('w-full', className)}>{children}</div>
);

export const StickySection = ({
  children,
  className = '',
  includeMobile = false,
  Component,
}: IStickySectionProps) => {
  const commonStyles =
    'flex flex-col justify-between bg-white bottom-0 mt-5 md:sticky md:left-0 md:z-10 md:mt-0';
  const mobileStyles = 'sticky left-0 z-10 mt-0';

  const StickyComponent = Component || BaseComponent;

  return (
    <StickyComponent
      className={clsx(commonStyles, className, {
        [mobileStyles]: includeMobile,
      })}>
      <Divider className="mb-3" />
      <div className="flex items-center justify-between mb-3">{children}</div>
    </StickyComponent>
  );
};
